import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'edcom-ui';
import CollectionsContext from '../../services/CollectionsContext';
import styles from '../../pages/game/game.module.less';

const CollectionsBookmark = ({ type, id, title, thumbnail }) => {
  const { isCollected, collectContent } = useContext(CollectionsContext);

  const contentModel = {
    id: id,
    type: type,
    title: title,
    thumbnail: thumbnail,
  };

  const handleCollect = event => {
    event.preventDefault();
    collectContent(type, id, contentModel);
  };

  const bookmarked = isCollected(type, id);

  const collectedText = !bookmarked
    ? 'Add to collection'
    : 'Added to collection';

  return (
    <Button
      className={styles.button}
      onClick={handleCollect}
      color="tertiary"
      title={collectedText}
    >
      <Icon
        name={!bookmarked ? 'bookmark' : 'bookmark-filled'}
        className={styles.icon}
        isImg={false}
      />
      {collectedText}
    </Button>
  );
};

CollectionsBookmark.propTypes = {
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
};

export default CollectionsBookmark;
